<template>
    <div class="tiers-payants">
        <h1 id="" class="frame-title">Suivi tiers payant</h1>
        <button id="fallbackFocus" class="d-none" tabindex="-1">Hidden Fallback</button>
        <div class="options_general">
            <h6 class="second-title">Sélection des factures :</h6>
            <div class="general-group">
                <div class="radios">
                    <div class="radio_btn">
                        <input type="radio" v-model="selectedOption" value="toutes" name="option-selection" class="form-radio" />
                        <label for="toutes" class="">Toutes</label>
                    </div>
                    <div class="radio_btn">
                        <input type="radio" v-model="selectedOption" value="nonrapprochees" name="option-selection" class="form-radio" />
                        <label for="non-rapprochees" class="">Non rapprochées</label>
                    </div>
                    <div class="radio_btn">
                        <input type="radio" v-model="selectedOption" value="rapprochees" name="option-selection" class="form-radio" />
                        <label for="rapprochees" class="">Rapprochées</label>
                    </div>
                </div>
                <div class="dates">
                    <div>
                        <label for="date-debut" class="block text-gray-600">FSE du :</label>
                        <input type="date"
                               id="date-debut"
                               v-model="recherche.date_debut"
                               :min="`1991-01-01`"
                               :max="recherche.date_fin"
                               class="input-item bg-white" />
                    </div>

                    <div>
                        <label for="date-fin" class="block text-gray-600">au :</label>
                        <input type="date"
                               id="date-fin"
                               v-model="recherche.date_fin"
                               :min="recherche.date_debut"
                               :max="getTodayDate()"
                               class="input-item bg-white" />
                    </div>
                </div>

            </div>

            <div class="general-group">
                <div class="praticien">
                    <label class="">Praticien :</label>
                    <input type="text"
                           :value="`${contrat.nom} ${contrat.prenom} (${contrat.ADELI.slice(0, -1)})`"
                           class="input-item bg-white"
                           disabled />
                </div>
                <div class="recherche">
                    <input type="text"
                           v-model="recherche.recherche"
                           placeholder="🔍 Recherche..."
                           class="input-item bg-white"
                           @keydown.enter="rechercherFactures" />
                </div>
                <div class="general-group">
                    <button @click="rechercherFactures" class="btn-recherche btn-primary">Rechercher</button>
                </div>
            </div>
            <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p> <!-- Message d'erreur -->
            <p v-if="successMessage" class="success-message">{{ successMessage }}</p> <!-- Message de succès -->
            <p v-if="secondRequestMessage" class="second-request-message">{{ secondRequestMessage }}</p> <!-- Message de succès -->
        </div>
        <div v-if="isLoading" class="d-flex justify-content-center align-items-center my-3">
            <div id="viewport">
                <div class="loader">
                    <div id="p1" class="point"></div>
                    <div id="p2" class="point"></div>
                    <div id="p3" class="point"></div>
                    <div id="p4" class="point"></div>
                </div>
                <p class="loading-msg">chargement</p>
            </div>
        </div>
        <div v-else>
            <div v-if="estPlein">
                <div class="barre-outils">
                    <button @click="imprimerGrille" class="btn-outil" title="Imprimer le tableau de suivi">🖨️ Imprimer</button>
                    <button @click="exporterGrille" class="btn-outil" title="Exporter le tableau (fichier texte)">📄 Exporter</button>
                </div>
                <div class="tableau-facture">
                    <div class="table-container">
                        <table class="tableau">
                            <thead>
                                <tr class="bg-n border-bottom" id="champs-tableau">
                                    <th class="ligne" @click="sortTable('date')">Date facture<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('code')">N°fse [lot]<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('ADELI')">P.s.<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('nom_patient')">Nom<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('nosecu')">Nir<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('organismeAMO')">Organisme amo<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('organismeCOMP')">Organisme comp<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('montantAmo')">Mont. amo<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('montantComp')">Mont. comp<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('montantTotal')">Mont. total<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('montantRestant')">Restant dû<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne">Options</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="border-bottom" v-for="facture in resultats" :key="facture">
                                    <td class="ligne" :title="facture.date" @click="selectFacture(facture); infosComplementairesFacture(facture);">{{facture.date}}</td>
                                    <td class="ligne" :title="facture.code + '/FSE' + facture.code + ' [' + facture.numero_lot + ']'" @click="selectFacture(facture); infosComplementairesFacture(facture);">{{facture.code}}/FSE{{facture.code}} [{{facture.numero_lot}}]</td>
                                    <td class="ligne" :title="contrat.ADELI + '-' + contrat.nom + ' ' + contrat.prenom" @click="selectFacture(facture); infosComplementairesFacture(facture);">{{contrat.ADELI}}-{{contrat.nom}} {{contrat.prenom}}</td>
                                    <td class="ligne" :title="facture.nom_patient + ' ' + facture.prenom_patient" @click="selectFacture(facture); infosComplementairesFacture(facture);">{{facture.nom_patient}} {{facture.prenom_patient}}</td>
                                    <td class="ligne" :title="facture.nosecu" @click="selectFacture(facture); infosComplementairesFacture(facture);">{{facture.nosecu}}</td>
                                    <td class="ligne" :title="facture.organismeAMO" @click="selectFacture(facture); infosComplementairesFacture(facture);">{{facture.organismeAMO}}</td>
                                    <td class="ligne" :title="facture.organismeCOMP" @click="selectFacture(facture); infosComplementairesFacture(facture);">{{facture.organismeCOMP}}</td>
                                    <td class="ligne" :title="facture.montantAmo" @click="selectFacture(facture); infosComplementairesFacture(facture);" :style="{ backgroundColor: facture.color_champ7 || 'transparent' }">{{facture.montantAmo}}</td>
                                    <td class="ligne" :title="facture.montantComp" @click="selectFacture(facture); infosComplementairesFacture(facture);" :style="{ backgroundColor: facture.color_champ8 || 'transparent' }">{{facture.montantComp}}</td>
                                    <td class="ligne" :title="facture.montantTotal" @click="selectFacture(facture); infosComplementairesFacture(facture);" :style="{ backgroundColor: facture.color_champ9 || 'transparent' }">{{facture.montantTotal}}</td>
                                    <td class="ligne" :title="facture.montantRestant" @click="selectFacture(facture); infosComplementairesFacture(facture);" :style="{ backgroundColor: facture.color_champ10 || 'transparent' }">{{facture.montantRestant}}</td>
                                    <td class="ligne" :title="'Options'" id="options" @click.stop="toggleMenu(facture, 'false')">
                                        <div class="troispoints">...</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!--Modal menu options facture-->
                <button type="button" class="btn btn-primary d-none" id="openMenuModal" data-toggle="modal" data-target="#menuModal">
                    Ouvrir modal
                </button>
                <div class="modal fade" id="menuModal" tabindex="-1" role="dialog" aria-labelledby="menuModalLabel" aria-hidden="true" v-bind:aria-hidden="modalmenuVisible ? 'false' : 'true'">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content shadow-lg rounded-lg">
                            <div class="modal-header" id="header_modal">
                                <div v-if="rapprocheSelected">
                                    <h5 class="modal-title" id="factureModalLabel">Rapprochement de la facture de : {{factureActuelle.Patient}}</h5>
                                </div>
                                <div v-else>
                                    <h5 class="modal-title" id="factureModalLabel">Détails de la facture n°{{nofact}}</h5>
                                </div>
                                <button type="button" class="close text-white" id="btn_modal_header" data-dismiss="modal" aria-label="Close" @click="closeModal('menu')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body" style="white-space: pre-line;">

                                <p v-if="successMessageRapport" class="success-message">{{ successMessageRapport }}</p> <!-- Message de succès -->
                                <div v-if="partLoading">
                                    <div class="load-wrapp">
                                        <div class="load-3">
                                            <div class="line"></div>
                                            <div class="line"></div>
                                            <div class="line"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <div v-if="rapprocheSelected" id="optionsMenu">
                                        <button @click.stop="afficherConfirmationRapprochement(factureActuelle)">🧩 Rapprocher manuellement le RSP</button>
                                    </div>
                                    <div v-else id="optionsMenu">
                                        <button @click.stop="visualiserFacture(factureActuelle)">👁️ Visualiser la facture</button>
                                        <div v-if="!factureActuelle.typeErreurAmo">
                                            <button @click.stop="ouvrirReclamationAMO(factureActuelle)">📤 Envoyer un rapport AMO</button>
                                        </div>
                                        <div v-if="!factureActuelle.typeErreurAmc">
                                            <button @click.stop="ouvrirReclamationCOMP(factureActuelle)">📤 Envoyer un rapport COMP</button>
                                        </div>
                                        <div v-if="factureActuelle.selectionEstGestionUnique">
                                            <div v-if="!factureActuelle.typeErreurAmo || !factureActuelle.typeErreurAmc">
                                                <button @click.stop="ouvrirReclamationAMOCOMP(factureActuelle)">📤 Envoyer un rapport AMO et COMP</button>
                                            </div>
                                        </div>
                                        <div v-else>
                                            <div v-if="!factureActuelle.typeErreurAmo && !factureActuelle.typeErreurAmc">
                                                <button @click.stop="ouvrirReclamationAMOCOMP(factureActuelle)">📤 Envoyer un rapport AMO et COMP</button>
                                            </div>
                                        </div>
                                        <div v-if="rougeAmo">
                                            <button @click.stop="forcerPartAMO(factureActuelle)">💳 Forcer la part AMO</button>
                                        </div>
                                        <div v-if="rougeComp">
                                            <button @click.stop="forcerPartCOMP(factureActuelle)">💳 Forcer la part COMP</button>
                                        </div>
                                        <div v-if="rougeAll">
                                            <button @click.stop="solderFacture(factureActuelle)">💰 Solder la facture</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer" data-dismiss="modal" @click="closeModal('menu')">Fermer</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Modal visualiser facture-->
                <button type="button" class="btn btn-primary d-none" id="openFactureModal" data-toggle="modal" data-target="#factureModal">
                    Ouvrir modal
                </button>
                <div class="modal fade" id="factureModal" tabindex="-1" role="dialog" aria-labelledby="factureModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" v-bind:aria-hidden="modalfactureVisible ? 'false' : 'true'">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content shadow-lg rounded-lg">
                            <div class="modal-header" id="header_modal">
                                <h5 class="modal-title" id="factureModalLabel">Détails de la facture n°{{nofact}}</h5>
                                <button type="button" class="close text-white" id="btn_modal_header" data-dismiss="modal" aria-label="Close" @click="closeModal('facture')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body" style="white-space: pre-line;">
                                {{ messageFacture }}
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer" data-dismiss="modal" @click="closeModal('facture')">Fermer</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Modal rapport de reclamation AMO-->
                <button type="button" class="btn btn-primary d-none" id="openRapportAMOModal" data-toggle="modal" data-target="#rapportAMOModal">
                    Ouvrir modal
                </button>
                <div class="modal fade" id="rapportAMOModal" tabindex="-1" role="dialog" aria-labelledby="rapportAMOModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" v-bind:aria-hidden="modalRapportAMOVisible ? 'false' : 'true'">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content shadow-lg rounded-lg">
                            <div class="modal-header" id="header_modal">
                                <h5 class="modal-title" id="rapportAMOModalLabel">Rapport de réclamation AMO</h5>
                                <button type="button" class="close text-white" id="btn_modal_header" data-dismiss="modal" aria-label="Close" @click="closeModal('rapportAMO')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div v-if="rapportLoading">
                                    <div class="load-wrapp">
                                        <div class="load-3">
                                            <div class="line"></div>
                                            <div class="line"></div>
                                            <div class="line"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p v-if="errorMessageRapport" class="error-message">{{ errorMessageRapport }}</p> <!-- Message d'erreur -->
                                    <textarea v-model="rapportAMOText" class="form-control" rows="8" placeholder="Rédigez votre rapport ici..."></textarea>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_fermer" data-dismiss="modal" @click="closeModal('rapportAMO')">Annuler</button>
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_envoyer" @click="envoyerRapportAMO">Envoyer</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Modal rapport de reclamation COMP-->
                <button type="button" class="btn btn-primary d-none" id="openRapportCOMPModal" data-toggle="modal" data-target="#rapportCOMPModal">
                    Ouvrir modal
                </button>
                <div class="modal fade" id="rapportCOMPModal" tabindex="-1" role="dialog" aria-labelledby="rapportCOMPModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" v-bind:aria-hidden="modalRapportCOMPVisible ? 'false' : 'true'">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content shadow-lg rounded-lg">
                            <div class="modal-header" id="header_modal">
                                <h5 class="modal-title" id="rapportCOMPModalLabel">Rapport de réclamation COMP</h5>
                                <button type="button" class="close text-white" id="btn_modal_header" data-dismiss="modal" aria-label="Close" @click="closeModal('rapportCOMP')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div v-if="rapportLoading">
                                    <div class="load-wrapp">
                                        <div class="load-3">
                                            <div class="line"></div>
                                            <div class="line"></div>
                                            <div class="line"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p v-if="errorMessageRapport" class="error-message">{{ errorMessageRapport }}</p> <!-- Message d'erreur -->
                                    <textarea v-model="rapportCOMPText" class="form-control" rows="8" placeholder="Rédigez votre rapport ici..."></textarea>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_fermer" data-dismiss="modal" @click="closeModal('rapportCOMP')">Annuler</button>
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_envoyer" @click="envoyerRapportCOMP">Envoyer</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Modal rapport de reclamation AMO et COMP-->
                <button type="button" class="btn btn-primary d-none" id="openRapportAMOCOMPModal" data-toggle="modal" data-target="#rapportAMOCOMPModal">
                    Ouvrir modal
                </button>
                <div class="modal fade" id="rapportAMOCOMPModal" tabindex="-1" role="dialog" aria-labelledby="rapportAMOCOMPModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" v-bind:aria-hidden="modalRapportAMOCOMPVisible ? 'false' : 'true'">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content shadow-lg rounded-lg">
                            <div class="modal-header" id="header_modal">
                                <h5 class="modal-title" id="rapportAMOCOMPModalLabel">Rapport de réclamation AMO et COMP</h5>
                                <button type="button" class="close text-white" id="btn_modal_header" data-dismiss="modal" aria-label="Close" @click="closeModal('rapportAMOCOMP')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div v-if="rapportLoading">
                                    <div class="load-wrapp">
                                        <div class="load-3">
                                            <div class="line"></div>
                                            <div class="line"></div>
                                            <div class="line"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p v-if="errorMessageRapport" class="error-message">{{ errorMessageRapport }}</p> <!-- Message d'erreur -->
                                    <textarea v-model="rapportAMOCOMPText" class="form-control" rows="8" placeholder="Rédigez votre rapport ici..."></textarea>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_fermer" data-dismiss="modal" @click="closeModal('rapportAMOCOMP')">Annuler</button>
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_envoyer" @click="envoyerRapportAMOCOMP">Envoyer</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Modal renseignement numéro de téléphone et/ou code région-->
                <button type="button" class="btn btn-primary d-none" id="openRenseignementModal" data-toggle="modal" data-target="#renseignementModal">
                    Ouvrir modal
                </button>
                <div class="modal fade" id="renseignementModal" tabindex="-1" role="dialog" aria-labelledby="renseignementModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" v-bind:aria-hidden="modalRenseignementVisible ? 'false' : 'true'">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content shadow-lg rounded-lg">
                            <div class="modal-header" id="header_modal">
                                <h5 class="modal-title" id="renseignementModalLabel">Le numéro de téléphone ainsi que la région sont nécessaires pour l'envoie de rapports de réclamation*</h5>
                                <button type="button" class="close text-white" id="btn_modal_header" data-dismiss="modal" aria-label="Close" @click="closeModal('renseignement')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p v-if="errorMessageRapport" class="error-message">{{ errorMessageRapport }}</p> <!-- Message d'erreur -->
                                <div v-show="afficherTelephone">
                                    <label>Numéro de téléphone</label>
                                    <input type="text" v-model="contrat.tel" placeholder="01 23 45 67 89" class="input-field" />
                                </div>
                                <div v-show="afficherRegion" class="choisirRegion">
                                    <label>Choisissez une région</label>
                                    <select v-model="regionChoisi" class="input-field" id="region">
                                        <option disabled value="">-- Sélectionnez une région --</option>
                                        <option v-for="region in regions" :key="region.codeRegion" :value="region.codeRegion">
                                            {{ region.fullName }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_fermer" data-dismiss="modal" @click="closeModal('renseignement')">Annuler</button>
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_envoyer" @click="enregistrerRenseignementTel">Enregistrer</button>
                            </div>
                        </div>
                    </div>
                </div>

                <!--Modal confirmation rapprochement manuel-->
                <button type="button" class="btn btn-primary d-none" id="openRapprochementModal" data-toggle="modal" data-target="#rapprochementModal">
                    Ouvrir modal
                </button>
                <div class="modal fade" id="rapprochementModal" tabindex="-1" role="dialog" aria-labelledby="rapprochementModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false" v-bind:aria-hidden="modalRapprochementVisible ? 'false' : 'true'">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div class="modal-content shadow-lg rounded-lg">
                            <div class="modal-header" id="header_modal">
                                <h5 class="modal-title" id="rapprochementModalLabel">Confirmez-vous le rapprochement manuel de la ligne sélectionnée : </h5>
                                <button type="button" class="close text-white" id="btn_modal_header" data-dismiss="modal" aria-label="Close" @click="closeModal('rapprochement')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div v-if="rapManuelBool">
                                    <div class="load-wrapp">
                                        <div class="load-3">
                                            <div class="line"></div>
                                            <div class="line"></div>
                                            <div class="line"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-else>
                                    <p v-if="errorMessageRapport" class="error-message">{{ errorMessageRapport }}</p> <!-- Message d'erreur -->
                                    <p>Rapprochement vers la facture : {{selectedFacture.code}}</p>
                                    <p>Montants attendus : {{selectedFacture.montantAmo}} / {{selectedFacture.montantComp}}</p>
                                    <p>Montants réglés : {{factureActuelle.MtAmo}} / {{factureActuelle.MtComp}}</p>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_fermer" data-dismiss="modal" @click="closeModal('rapprochement')">Annuler</button>
                                <button type="button" class="btn btn-secondary" id="btn_modal_footer_envoyer" @click="rapprochementManuel">Confirmer</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tableau-reglement" v-if="reglementPlein">
                    <h6 class="second-title">Règlements associés :</h6>
                    <div class="table-container">
                        <table class="tableau">
                            <thead>
                                <tr class="bg-n border-bottom" id="champs-tableau">
                                    <th class="ligne" @click="sortTable('date_reglement')">Date<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('mt_amo')">Mt amo<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('mt_comp')">Mt comp<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('mt_sup')">Mt sup<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('mt_vir')">Mt vir<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('type_retour')">Typ<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('payeur')">Payeur<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('libelle')">Libelle<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('reference')">Reference<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('ref_dette')">Ref dette<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('code_nature')">Code nature<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('libelle_nature')">Libelle nature<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('code_recupere')">Code recup<span class="chevron">&lt;&gt;</span></th>
                                    <th class="ligne" @click="sortTable('libelle_recupere')">Libelle recup<span class="chevron">&lt;&gt;</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="border-bottom">
                                    <td class="ligne" :title="selectedFacture.date_reglement">{{selectedFacture.date_reglement}}</td>
                                    <td class="ligne" :title="selectedFacture.mt_amo">{{selectedFacture.mt_amo}}</td>
                                    <td class="ligne" :title="selectedFacture.mt_comp">{{selectedFacture.mt_comp}}</td>
                                    <td class="ligne" :title="selectedFacture.mt_sup">{{selectedFacture.mt_sup}}</td>
                                    <td class="ligne" :title="selectedFacture.mt_vir">{{selectedFacture.mt_vir}}</td>
                                    <td class="ligne" :title="selectedFacture.type_retour">{{selectedFacture.type_retour}}</td>
                                    <td class="ligne" :title="selectedFacture.payeur">{{selectedFacture.payeur}}</td>
                                    <td class="ligne" :title="selectedFacture.libelle">{{selectedFacture.libelle}}</td>
                                    <td class="ligne" :title="selectedFacture.reference">{{selectedFacture.reference}}</td>
                                    <td class="ligne" :title="selectedFacture.ref_dette">{{selectedFacture.ref_dette}}</td>
                                    <td class="ligne" :title="selectedFacture.code_nature">{{selectedFacture.code_nature}}</td>
                                    <td class="ligne" :title="selectedFacture.libelle_nature">{{selectedFacture.libelle_nature}}</td>
                                    <td class="ligne" :title="selectedFacture.code_recupere">{{selectedFacture.code_recupere}}</td>
                                    <td class="ligne" :title="selectedFacture.libelle_recupere">{{selectedFacture.libelle_recupere}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-else>
                    <p class="tableau-vide">Aucun règlement associé trouvé.</p>
                </div>


                <!-- METTRE UN V-IF SUR CETTE CLASS -->
                <div class="tableau-complementaire">
                    <h6 class="second-title">Informations complémentaires :</h6>

                    <!-- Menu -->
                    <div class="menu-tableaux">
                        <button v-for="(tab, index) in tabs"
                                :key="index"
                                :class="{ active: selectedTab === index }"
                                @click="selectedTab = index">
                            {{ tab.label }}
                        </button>
                    </div>

                    <!-- Affichage des 4 tableaux différents -->
                    <div class="table-container">
                        <div v-if="selectedTab === 0">
                            <!-- Erreurs/rejets -->
                            <div v-if="tabErreurPlein">
                                <div class="table-container">
                                    <table class="tableau">
                                        <thead>
                                            <tr class="bg-n border-bottom" id="champs-tableau">
                                                <th class="ligne">Date<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Libellé<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Niveau<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Prest<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Cor<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Libellé<span class="chevron">&lt;&gt;</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="border-bottom" v-for="erreur in tabErreur" :key="erreur">
                                                <td class="ligne" :title="erreur.DateRSP">{{erreur.DateRSP}}</td>
                                                <td class="ligne" :title="erreur.Libelle">{{erreur.Libelle}}</td>
                                                <td class="ligne" :title="erreur.Niveau">{{erreur.Niveau}}</td>
                                                <td class="ligne"></td>
                                                <td class="ligne" :title="erreur.Corrigee">{{erreur.Corrigee}}</td>
                                                <td class="ligne" :title="erreur.Remarques">{{erreur.Remarques}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else>
                                <p class="tableau-vide">Aucune donnée trouvée.</p>
                            </div>
                        </div>
                        <div v-else-if="selectedTab === 1">
                            <!-- RSP non rapprochés -->
                            <div v-if="tabRspPlein">
                                <div class="table-container">
                                    <table class="tableau">
                                        <thead>
                                            <tr class="bg-n border-bottom" id="champs-tableau">
                                                <th class="ligne">Date<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Facture<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Patient<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Nir<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Emetteur<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Mt AMO<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Mt COMP<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Mt SUP<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Mt VIR<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">VIR 1<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">VIR 2<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Restant dû<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">ID<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Options</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="border-bottom" v-for="rsp in tabRSP" :key="rsp">
                                                <td class="ligne" :title="rsp.DateComptable">{{rsp.DateComptable}}</td>
                                                <td class="ligne" :title="rsp.Facture">{{rsp.Facture}}</td>
                                                <td class="ligne" :title="rsp.Patient">{{rsp.Patient}}</td>
                                                <td class="ligne" :title="rsp.Nir">{{rsp.Nir}}</td>
                                                <td class="ligne" :title="rsp.Emetteur">{{rsp.Emetteur}}</td>
                                                <td class="ligne" :title="rsp.MtAmo" :style="{ backgroundColor: rsp.ColorAmo || 'transparent' }">{{rsp.MtAmo}}</td>
                                                <td class="ligne" :title="rsp.MtComp" :style="{ backgroundColor: rsp.ColorComp || 'transparent' }">{{rsp.MtComp}}</td>
                                                <td class="ligne" :title="rsp.MtSup">{{rsp.MtSup}}</td>
                                                <td class="ligne" :title="rsp.MtVir">{{rsp.MtVir}}</td>
                                                <td class="ligne" :title="rsp.Vir1">{{rsp.Vir1}}</td>
                                                <td class="ligne" :title="rsp.Vir2">{{rsp.Vir2}}</td>
                                                <td class="ligne"></td>
                                                <td class="ligne" :title="rsp.ID">{{rsp.ID}}</td>
                                                <td class="ligne" :title="'Option'" id="options" @click.stop="toggleMenu(rsp, 'true')">
                                                    <div class="troispointsnonrapproches">...</div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else>
                                <p class="tableau-vide">Aucune donnée trouvée.</p>
                            </div>
                        </div>
                        <div v-else-if="selectedTab === 2">
                            <!-- Opérations ponctuelles -->
                            <div v-if="tabPonctuellePlein">
                                <div class="table-container">
                                    <table class="tableau">
                                        <thead>
                                            <tr class="bg-n border-bottom" id="champs-tableau">
                                                <th class="ligne">Date<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Emetteur<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Nir<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Montant<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">TYP<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">VIR 1<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">VIR 2<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Mt VIR<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Période<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Début<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Fin<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Dette<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Code<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Libellé<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Code récup<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Libellé récup<span class="chevron">&lt;&gt;</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="border-bottom" v-for="operation in tabOperationsPonctuelles" :key="operation">
                                                <td class="ligne" :title="operation.DatePonc">{{operation.DatePonc}}</td>
                                                <td class="ligne" :title="operation.Emetteur">{{operation.Emetteur}}</td>
                                                <td class="ligne" :title="operation.Nir">{{operation.Nir}}</td>
                                                <td class="ligne" :title="operation.Montant">{{operation.Montant}}</td>
                                                <td class="ligne" :title="operation.Typ">{{operation.Typ}}</td>
                                                <td class="ligne" :title="operation.Vir1">{{operation.Vir1}}</td>
                                                <td class="ligne" :title="operation.Vir2">{{operation.Vir2}}</td>
                                                <td class="ligne" :title="operation.MtVir">{{operation.MtVir}}</td>
                                                <td class="ligne" :title="operation.Periode">{{operation.Periode}}</td>
                                                <td class="ligne" :title="operation.Debut">{{operation.Debut}}</td>
                                                <td class="ligne" :title="operation.Fin">{{operation.Fin}}</td>
                                                <td class="ligne" :title="operation.Dette">{{operation.Dette}}</td>
                                                <td class="ligne" :title="operation.Code">{{operation.Code}}</td>
                                                <td class="ligne" :title="operation.Libelle">{{operation.Libelle}}</td>
                                                <td class="ligne" :title="operation.CodeRecup">{{operation.CodeRecup}}</td>
                                                <td class="ligne" :title="operation.LibelleRecup">{{operation.LibelleRecup}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else>
                                <p class="tableau-vide">Aucune donnée trouvée.</p>
                            </div>
                        </div>
                        <div v-else-if="selectedTab === 3">
                            <!-- Rapport de réclamation -->
                            <div v-if="tabRapportPlein">
                                <div class="table-container">
                                    <table class="tableau">
                                        <thead>
                                            <tr class="bg-n border-bottom" id="champs-tableau">
                                                <th class="ligne">Date envoi<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Libellé<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Etat<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Date retour<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Retour<span class="chevron">&lt;&gt;</span></th>
                                                <th class="ligne">Erreur<span class="chevron">&lt;&gt;</span></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr class="border-bottom" v-for="rapport in tabRapport" :key="rapport">
                                                <td class="ligne" :title="rapport.DateEnvoi">{{rapport.DateEnvoi}}</td>
                                                <td class="ligne" :title="rapport.Libelle">{{rapport.Libelle}}</td>
                                                <td class="ligne" :title="rapport.Etat">{{rapport.Etat}}</td>
                                                <td class="ligne" :title="rapport.DateRetour">{{rapport.DateRetour}}</td>
                                                <td class="ligne" :title="rapport.Retour">{{rapport.Retour}}</td>
                                                <td class="ligne" :title="rapport.Erreur">{{rapport.Erreur}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div v-else>
                                <p class="tableau-vide">Aucune donnée trouvée.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="d-flex justify-content-center align-items-center my-3">
                    <p class="tableau-vide">Aucuns résultats trouvés.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
    /* ANIMATIONS DE CHARGEMENT */

    #viewport {
        position: relative;
        top: 0;
        left: 0;
        height: 250px;
        width: 120px;
        margin-top: 50px;
    }


    .loading-msg {
        color: rgba(17, 147, 147, .6);
        font-size: 16px;
        font-family: 'Helvetica';
        font-weight: lighter;
        text-transform: uppercase;
        text-align: center;
        position: absolute;
        top: 62%;
        width: 100%;
        animation: msg 3s infinite linear;
    }

    .loader {
        position: absolute;
        bottom: 44%;
        left: 25%;
        width: 50%;
        height: 40%;
    }

    .point {
        position: absolute;
        width: 6px;
        height: 6px;
        background: rgba(17, 147, 147);
        border-radius: 10px;
        box-shadow: 0 0 18px 4px rgba(17, 147, 147);
    }

    #p1 {
        bottom: 0px;
        left: 20%;
        animation: loading-p1 3s infinite linear;
    }

    #p2 {
        bottom: 0px;
        left: 40%;
        animation: loading-p2 2.5s infinite linear;
    }

    #p3 {
        bottom: 0px;
        left: 60%;
        animation: loading-p3 2s infinite linear;
    }

    #p4 {
        bottom: 0px;
        left: 80%;
        animation: loading-p4 5s infinite linear;
    }
    
    @keyframes loading-p1{
        0% {
            transform: translate3d(0px);
        }
        25% {
            transform: perspective(500px) translate3d(15px, -100px, 0);
        }
        50% {
            transform: perspective(500px) translate3d(70px, -70px, 0);
        }
        75% {
            transform: perspective(500px) translate3d(80px, -130px, 0);
        }
        100% {
            transform: perspective(500px) translateX(0);
        }
    }
    
    @keyframes loading-p2{
        0% {
            transform: translate3d(0px);
        }
        25% {
            transform: translate3d(40px, -30px, 0);
        }
        50% {
            transform: translate3d(-10px, -100px, 0);
        }
        75% {
            transform: translate3d(-10px, -130px, 0);
        }
        100% {
            transform: translateX(0);
        }

    }
    

    @keyframes loading-p3{
        0% {
            transform: translate3d(0px);
        }
        25% {
            transform: translate3d(-40px, -10px, 0);
        }
        50% {
            transform: translate3d(70px, -70px, 0);
        }
        75% {
            transform: translate3d(40px, -160px, 0);
        }
        100% {
            transform: translateX(0);
        }
    }
    

    @keyframes loading-p4{
        0% {
            transform: translate3d(0px);
        }
        25% {
            transform: translate3d(-60px, -50px, 0);
        }
        50% {
            transform: translate3d(-140px, -20px, 0);
        }
        75% {
            transform: translate3d(-50px, -130px, 0);
        }
        100% {
            transform: translateX(0);
        }
    }
    

    @keyframes msg{
        50% {
            opacity: .3;
        }
        100% {
            opacity: 1;
        }
    }

    /* OPTIONS DE RECHERCHE DE FACTURE */
    .tiers-payants {
        padding: 20px;
        max-width: 100%;
        overflow-x: hidden; /* la page ne deborde pas : seuls les .table-container defilent */
        background-color: rgba(223, 207, 215, 0.1);
    }

    .frame-title {
        color: rgba(17, 147, 147);
        font-weight: bold;
        text-align: center; 
        margin-bottom: 20px;
    }

    .second-title {
        font-weight: bold;
    }

    .options_general {
        display: flex;
        flex-direction: column;
    }

    .general-group {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        gap: 50px;
    }

    .radios {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
    }

    .dates {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
    }

    #date-fin {
        margin-top: 10px;
        max-width: 100%
    }

    #date-debut {
        max-width: 100%;
    }

    .praticien{
        padding:0px;
        margin: 0px;
    }

    .input-item {
        border: none;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    }

    .btn-recherche {
        color: rgba(17, 147, 147);
        font-weight: bold;
        background-color: white;
        border: solid 1px rgba(17, 147, 147);
        border-radius: 16px;
    }

        .btn-recherche:hover {
            color: white;
            background-color: rgba(17, 147, 147);
            border: none;
        }

    /* BARRE D'OUTILS (IMPRESSION / EXPORT) */
    .barre-outils {
        display: flex;
        gap: 10px;
        justify-content: flex-end;
        margin-top: 15px;
    }

    .btn-outil {
        color: rgba(17, 147, 147);
        font-weight: bold;
        background-color: white;
        border: solid 1px rgba(17, 147, 147);
        border-radius: 16px;
        padding: 5px 14px;
    }

        .btn-outil:hover {
            color: white;
            background-color: rgba(17, 147, 147);
            border: none;
        }

    /* TABLEAUX FACTURES */
    #champs-tableau {
        color: darkgray;
    }

    .ligne {
        padding: 0.5rem;
    }

    .tableau {
        width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
    }

    .tableau thead {
        position: sticky;
        top: 0;
        background: white;
        width: 100%;
        z-index: 10;
    }

    .tableau tbody tr:hover {
        background-color: rgba(0, 0, 0, 0.04);
        font-weight: bold;
        cursor: pointer;
    }

    .tableau thead tr th:hover{
        color: black;
        cursor: pointer;
    }

    .chevron {
        font-size: 10px;
        transform: rotate(90deg);
        display: inline-block;
        cursor: pointer;
        transition: transform 0.3s ease;
    }

        .chevron:hover {
            transform: rotate(360deg);
        }

    .table-container {
        width: 100%;
        border: none;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
        max-height: 800px;
        overflow-x: auto;
        overflow-y: auto;
    }

        .table-container table {
            width: 100%;
            border: none;
            overflow-x: auto;
            overflow-y: auto;
        }

    .tableau-facture{
        margin-top: 15px;
    }

    .tableau-reglement {
        margin-top: 50px;
    }

    .tableau-complementaire {
        margin-top: 50px;
    }

    .tableau {
        width: 100%;
        min-width: 800px;
    }

        .table th, .table td {
            padding: 0;
            text-align: left;
        }

    .tableau-vide{
        color: black;
        font-size: 1rem;
        font-weight: bold;
        padding: 100px;
    }

    .tableau th,
    .tableau td {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 150px;
    }

    /* MENU TABLEAU COMPLEMENTAIRE */

    .menu-tableaux {
        display: flex;
        gap: 10px;
        margin-bottom: 10px;
    }

        .menu-tableaux button {
            padding: 5px 10px;
            cursor: pointer;
            background-color: white;
            color: rgba(17, 147, 147);
            border: 1px solid rgba(17, 147, 147);
            border-radius: 12px;
            font-weight: bold;
        }

            .menu-tableaux button.active {
                background-color: rgba(17, 147, 147);
                color: white;
            }

    /* MESSAGES DE REUSSITES / ECHECS */
    .error-message {
        color: red;
        font-size: 1rem;
        font-weight: bold;
        margin-top: 5px;
    }

    .success-message {
        color: green;
        font-size: 1rem;
        font-weight: bold;
        margin-top: 5px;
    }

    .second-request-message {
        color: orange;
        font-size: 1rem;
        font-weight: bold;
        margin-top: 5px;
    }

    /* OPTIONS FACTURES TIERS PAYANTS */
    #options {
        position: relative;
        font-weight: bold;
        color: rgba(17, 147, 147);
        font-size: 30px;
    }

    .troispoints {
        margin-left: 10px;
        cursor: pointer;

    }

    .troispointsnonrapproches {
        margin-left: 0px;
        margin-right: 20px;
        cursor: pointer;
    }

    #optionsMenu {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

        #optionsMenu button {
            background-color: none;
            border: 1px solid rgba(17, 147, 147);
            color: black;
            font-weight: bold;
            padding: 10px;
            margin-top: 10px;
            margin-left: 10px;
        }

            #optionsMenu button:hover {
                background-color: rgba(17, 147, 147);
                color: white;
            }

    /* MODAL FACTURE */
    .modal-header {
        background-color: rgba(17, 147, 147);
        color: white;
    }

    #factureModalLabel{
        font-weight: bold;
    }

    #btn_modal_footer {
        background-color: white;
        border: 1px solid rgba(17, 147, 147);
        color: rgba(17, 147, 147);
        font-weight: bold;
    }

        #btn_modal_footer:hover {
            background-color: rgba(17, 147, 147);
            color: white;
        }

    #btn_modal_header:hover {
        background-color: rgba(17, 147, 147);
    }

    /* MODAL RAPPORT RECLAMATION */

    #btn_modal_footer_fermer {
        background-color: white;
        border: 1px solid red;
        color: red;
        font-weight: bold;
    }
        #btn_modal_footer_fermer:hover {
            background-color: red;
            color: white;
        }

    #btn_modal_footer_envoyer {
        background-color: white;
        border: 1px solid green;
        color: green;
        font-weight: bold;
    }

        #btn_modal_footer_envoyer:hover {
            background-color: green;
            color: white;
        }

    /* MODAL RENSEIGNEMENTS */
    .input-field {
        margin-left: 10px;
        border: 0.5px solid black;
        border-radius: 12px;
        padding: 0.8rem;
        max-width: 100%;
    }

    .choisirRegion {
        margin-top : 10px;
    }

    /* CHARGEMENT FORCEMENT PART AMO COMP */
    .load-wrapp {
        display: flex;
        margin: 0 10px 10px 0;
        padding: 20px 20px 20px;
        border-radius: 5px;
        text-align: center;
        align-items: center;
        justify-content: center;
    }

    .line {
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 15px;
        background-color: rgba(17, 147, 147);
    }

    .load-3 .line:nth-last-child(1) {
        animation: loadingC 0.6s 0.1s linear infinite;
    }

    .load-3 .line:nth-last-child(2) {
        animation: loadingC 0.6s 0.2s linear infinite;
    }

    .load-3 .line:nth-last-child(3) {
        animation: loadingC 0.6s 0.3s linear infinite;
    }

    @keyframes loadingC {
        0% {
            transform: translate(0, 0);
        }

        50% {
            transform: translate(0, 15px);
        }

        100% {
            transform: translate(0, 0);
        }
    }

    /* RESPONSIVE */
    @media (max-width: 768px) {
        .general-group {
            flex-direction: column;
        }

        .options_general {
            flex-direction: column;
        }

        .table-container {
            max-height: 700px;
        }

        .tableau {
            min-width: 400px;
        }
    }
</style>

<script>
    import { defineComponent } from 'vue';
    import axios from 'axios';
    import Values from "../script/Values";
    import RequestManager from "../script/request";
    import Client from "../script/Client";
    import { mapGetters } from 'vuex';
    import TiersPayants from '../script/TiersPayants';
    import Region from '../script/Region';

    export default defineComponent({
        data() {
            return {
                message: 'Gestion Tiers Payant',
                claims: { email: "" },
                contrat: {
                    ADELI: "",
                    nom: "",
                    prenom: "",
                    tel: "",
                    email: ""
                },
                recherche: {
                    adeli: '',
                    date_debut: this.getOneMonthBeforeToday(),
                    date_fin: this.getTodayDate(),
                    recherche: "",
                    nonrapprochees: false,
                    rapprochees: false,
                    toutes: true,
                },
                regions: [
                    { nameFile: "hauts_de_france", fullName: "Hauts-de-France", codeRegion: "32" },
                    { nameFile: "normandie", fullName: "Normandie", codeRegion: "28" },
                    { nameFile: "reunion", fullName: "La Réunion", codeRegion: "04" },
                    { nameFile: "provence", fullName: "Provence-Alpes-Côte d'Azur", codeRegion: "93" },
                    { nameFile: "occitanie", fullName: "Occitanie", codeRegion: "76" },
                    { nameFile: "mayotte", fullName: "Mayotte", codeRegion: "06" },
                    { nameFile: "martinique", fullName: "Martinique", codeRegion: "02" },
                    { nameFile: "loire", fullName: "Pays de la Loire", codeRegion: "52" },
                    { nameFile: "ile_de_france", fullName: "Ile-de-France", codeRegion: "11" },
                    { nameFile: "guyane", fullName: "Guyane", codeRegion: "03" },
                    { nameFile: "guadeloupe", fullName: "Guadeloupe", codeRegion: "01" },
                    { nameFile: "corse", fullName: "Corse", codeRegion: "94" },
                    { nameFile: "centre", fullName: "Centre-Val de Loire", codeRegion: "24" },
                    { nameFile: "bretagne", fullName: "Bretagne", codeRegion: "53" },
                    { nameFile: "bourgogne", fullName: "Bourgogne-Franche-Comté", codeRegion: "27" },
                    { nameFile: "auvergne", fullName: "Auvergne-Rhône-Alpes", codeRegion: "84" },
                    { nameFile: "aquitaine", fullName: "Nouvelle-Aquitaine", codeRegion: "75" },
                    { nameFile: "grand_est", fullName: "Grand Est", codeRegion: "44" }
                ],
                selectedOption: "toutes",
                errorMessage: "",
                successMessage: "",
                secondRequestMessage: "",
                resultats: [],
                isLoading: false,
                estPlein: false,
                selectedFacture: [],
                reglementPlein: false,
                abortController: null,
                rougeAmo: false,
                rougeComp: false,
                rougeAll: false,
                messageFacture: "",
                modalfactureVisible: false,
                modalRapportAMOVisible: false,
                modalRapportCOMPVisible: false,
                modalRenseignementVisible: false,
                modalmenuVisible: false,
                modalRapportAMOCOMPVisible: false,
                modalRapprochementVisible: false,
                afficherTelephone: false,
                afficherRegion: false,
                nofact: "",
                //quill: null,
                rapportAMOText: "",
                rapportCOMPText: "",
                rapportAMOCOMPText: "",
                errorMessageRapport: "",
                successMessageRapport: "",
                factureActuelle: [],
                codeRegion: "",
                regionChoisi: "",
                partLoading: false,
                selectedTab: 0,
                tabs: [
                    { label: 'Erreurs/rejets' },
                    { label: 'RSP non rapprochés' },
                    { label: 'Opérations ponctuelles' },
                    { label: 'Rapport de réclamation' }
                ],
                tabErreur: [],
                tabRSP: [],
                tabOperationsPonctuelles: [],
                tabRapport: [],
                tabRapportPlein: false,
                tabRspPlein: false,
                tabPonctuellePlein: false,
                tabErreurPlein: false,
                rapprocheSelected: false,
                rapManuelBool: false,
                rapportLoading: false
            };
        },
        watch: {
            selectedOption: function (newValue) {
                if (newValue === 'toutes') {
                    this.recherche.toutes = true;
                    this.recherche.nonrapprochees = false;
                    this.recherche.rapprochees = false;
                } else if (newValue === 'nonrapprochees') {
                    this.recherche.toutes = false;
                    this.recherche.nonrapprochees = true;
                    this.recherche.rapprochees = false;
                } else if (newValue === 'rapprochees') {
                    this.recherche.toutes = false;
                    this.recherche.nonrapprochees = false;
                    this.recherche.rapprochees = true;
                }
            }
        },
        methods: {
            // Le backend serialise ses proprietes en PascalCase (Code, Nom_patient, OrganismeAMO,
            // MontantAmo...) alors que le template lit des clefs a initiale minuscule. On abaisse
            // la 1re lettre de chaque clef : Code->code, Nom_patient->nom_patient,
            // OrganismeAMO->organismeAMO, MontantAmo->montantAmo, Color_champ7->color_champ7.
            // Idempotent sur les clefs deja minuscules (typeErreurAmo).
            normaliserClesPascalCase(obj) {
                if (!obj || typeof obj !== 'object') {
                    return obj;
                }
                const resultat = {};
                for (const cle of Object.keys(obj)) {
                    const nouvelleCle = cle.charAt(0).toLowerCase() + cle.slice(1);
                    resultat[nouvelleCle] = obj[cle];
                }
                return resultat;
            },
            async codeRecupRegion() {
                try {
                    const response = await Region.getMyRegion();
                    if (response) {
                        this.codeRegion = this.regions.find(region => region.nameFile === response.name)?.codeRegion ?? "00";
                        console.log("Code récupéré : ", this.codeRegion);
                    }
                } catch (error) {
                    if (error.response && error.response.status === 404) {
                        console.error("Not found : ", error);
                    } else {
                        console.error("Erreur lors de la récupération de votre région : ", error);
                    }
                }
            },
            async fetchClaims() {
                const token = RequestManager.getToken();
                if (!token) {
                    console.warn("TOKEN == null");
                    return;
                }
                this.claims = await Values.GetClaims(token);
                if (this.claims?.email) {
                    await this.fetchContrat();
                } else {
                    console.error("Impossible de récupérer l'email de l'utilisateur.");
                }
            },
            async fetchContrat() {
                if (!this.claims?.email) {
                    alert("L'email de l'utilisateur est introuvable !");
                    return;
                }
                try {
                    const brut = await Client.getClientWithEmail(this.claims.email) || {};
                    // ADELI est deja en capitales cote backend (serialisation verbatim) donc utilisable
                    // tel quel ; Nom/Prenom/Tel/Email arrivent en PascalCase -> on retombe sur les
                    // clefs attendues par le template (nom, prenom, tel, email).
                    this.contrat = {
                        ...brut,
                        ADELI: brut.ADELI ?? brut.adeli ?? "",
                        nom: brut.Nom ?? brut.nom ?? "",
                        prenom: brut.Prenom ?? brut.prenom ?? "",
                        tel: brut.Tel ?? brut.tel ?? "",
                        email: brut.Email ?? brut.email ?? ""
                    };
                    console.log("le contrat tiers payants :", this.contrat);
                    if (this.contrat?.ADELI) {
                        await this.rechercherFactures();
                    } else {
                        console.error("Impossible de récupérer le numéro ADELI");
                    }
                } catch (error) {
                    console.error("Erreur lors de la récupération du contrat :", error);
                }
            },
            updateSelection(selected) {
                if (selected === 'toutes') {
                    this.recherche.nonrapprochees = false;
                    this.recherche.rapprochees = false;
                    this.recherche.toutes = true;
                } else if (selected === 'nonrapprochees') {
                    this.recherche.toutes = false;
                    this.recherche.rapprochees = false;
                    this.recherche.nonrapprochees = true;
                } else if (selected === 'rapprochees') {
                    this.recherche.toutes = false;
                    this.recherche.nonrapprochees = false;
                    this.recherche.rapprochees = true;
                }
            },
            getTodayDate() {
                let date = new Date();
                return this.formatToYYYYMMDD(date);
            },
            getOneMonthBeforeToday() {
                let date = new Date();
                date.setMonth(date.getMonth() - 1);
                return this.formatToYYYYMMDD(date);
            },
            formatToYYYYMMDD(date) {
                if (!date) return "";
                if (date instanceof Date) {
                    return date.toISOString().split('T')[0];
                }
                const [jour, mois, annee] = date.split("/");
                return `${annee}-${mois}-${jour}`;
            },
            async rechercherFactures() {
                this.tabRapportPlein = false;
                this.tabRspPlein = false;
                this.tabPonctuellePlein = false;
                this.tabErreurPlein = false;
                this.reglementPlein = false;
                this.tabErreur = [];
                this.tabRapport = [];
                this.tabRSP = [];
                this.tabOperationsPonctuelles = [];
                this.selectedFacture = [];
                this.successMessageRapport = "";
                this.errorMessage = "";
                this.successMessage = "";
                this.secondRequestMessage = "";

                if (this.abortController) {
                    this.abortController.abort();
                }

                this.abortController = new AbortController();
                const signal = this.abortController.signal;

                this.isLoading = true;
                this.recherche.adeli = this.contrat.ADELI.slice(0, -1);
                if (!this.recherche.date_debut && !this.recherche.date_fin) {
                    this.recherche.date_debut = this.getOneMonthBeforeToday();
                    this.recherche.date_fin = this.getTodayDate();
                }
                if (!this.recherche.date_fin) {
                    this.recherche.date_fin = this.getTodayDate();
                }
                if (this.recherche.date_fin < `1991-01-01`) {
                    this.errorMessage = "Veuillez saisir une date de fin supérieure au 31/12/1990.";
                    console.log(this.errorMessage);
                    this.successMessage = "";
                    this.secondRequestMessage = "";
                    this.recherche.date_debut = this.getOneMonthBeforeToday();
                    this.recherche.date_fin = this.getTodayDate();
                    this.isLoading = false;
                    return;
                }
                if (!this.recherche.date_debut) {
                    this.errorMessage = "Veuillez saisir une date de début.";
                    this.successMessage = "";
                    this.secondRequestMessage = "";
                    this.isLoading = false;
                    return;
                }
                if (this.recherche.date_debut > this.getTodayDate()) {
                    this.errorMessage = "Veuillez saisir une date de début inférieure à la date d'aujourd'hui.";
                    this.successMessage = "";
                    this.secondRequestMessage = "";
                    this.recherche.date_debut = this.getOneMonthBeforeToday();
                    this.recherche.date_fin = this.getTodayDate();
                    this.isLoading = false;
                    return;
                }
                console.log("Données de recherche envoyées :", this.recherche);
                if (!this.recherche?.adeli) {
                    console.warn("adeli == null");
                    this.isLoading = false;
                    return;
                }
                try {
                    this.isLoading = true;
                    const facturesBrutes = await TiersPayants.postRechercheFacturesWithJson(this.recherche, signal);
                    // Backend en PascalCase -> on normalise les clefs pour le template (code, nom_patient,
                    // organismeAMO, montantAmo, color_champ7...).
                    this.resultats = (facturesBrutes || []).map(f => this.normaliserClesPascalCase(f));
                    console.log("Résultats de la recherche : ", this.resultats);
                    if (this.resultats.length == 0) {
                        this.estPlein = false;
                        this.errorMessage = "";
                        this.successMessage = "";
                        this.secondRequestMessage = "";
                        this.abortController = null;
                        this.isLoading = false;
                    } else {
                        this.estPlein = true;
                        this.errorMessage = "";
                        this.secondRequestMessage = "";
                        this.successMessage = "Factures récupérées avec succès !";
                        this.abortController = null;
                        this.isLoading = false;
                    }
                } catch (error) {
                    if (error.name === 'CanceledError') {
                        // Si la requête est annulée, rien ne doit être affiché
                        this.secondRequestMessage = "Requête annulée : nouvelle recherche en cours...";
                        this.resultats = [];
                        this.estPlein = false;
                        this.isLoading = true;
                        console.log("Recherche annulée");
                    } else {
                        console.error("Erreur lors de la recherche des factures : ", error);
                        this.errorMessage = "Une erreur s'est produite lors de la récupération des factures.";
                        this.isLoading = false;
                    }
                }
            },
            sortTable(key) {
                if (this.sortKey === key) {
                    this.sortOrder *= -1;
                } else {
                    this.sortKey = key;
                    this.sortOrder = 1;
                }

                this.resultats.sort((a, b) => {
                    let valA = a[key];
                    let valB = b[key];

                    if (key === "date" || key === "date_reglement" && valA && valB) {
                        valA = new Date(valA.split("/").reverse().join("-")).getTime();
                        valB = new Date(valB.split("/").reverse().join("-")).getTime();
                    }

                    if (key === "nosecu" || key === "code" || key === "ADELI" || key === "organismeCOMP" || key === "montantAmo" || key === "montantComp" || key === "montantTotal" || key === "montantRestant" || key === "mt_amo" || key === "mt_comp" || key === "mt_sup" || key === "mt_vir" || key === "type_retour" || key === "reference" || key === "ref_dette" || key === "code_nature" || key === "code_recupere") {
                        valA = parseInt(valA, 10);
                        valB = parseInt(valB, 10);
                    }

                    if (key === "organismeAMO" && valA && valB) {
                        let partsA = valA.split("/").map(num => parseInt(num, 10));
                        let partsB = valB.split("/").map(num => parseInt(num, 10));

                        for (let i = 0; i < partsA.length; i++) {
                            if (partsA[i] !== partsB[i]) {
                                return (partsA[i] - partsB[i]) * this.sortOrder;
                            }
                        }
                    }

                    return (valA > valB ? 1 : -1) * this.sortOrder;
                });
            },
            selectFacture(facture) {
                this.selectedFacture = facture;
                if (this.selectedFacture.length == 0) {
                    this.reglementPlein = false;
                } else {
                    this.reglementPlein = true;
                }
            },
            async infosComplementairesFacture(facture) {
                this.selectedFacture = facture;

                if (this.selectedFacture.no_fact_tla == "0") {
                    this.nofact = this.selectedFacture.code;
                } else {
                    this.nofact = this.selectedFacture.no_fact_tla;
                }
                var noAMO = this.selectedFacture.organismeAMO;
                const partsAMO = noAMO.split("/").map(num => num.trim());
                console.log("n° Emetteur : ", partsAMO[0]);
                try {
                    const data = {
                        nofact: this.nofact,
                        noEmetteur: partsAMO[0],
                        idps: this.contrat.ADELI
                    }

                    var response = await TiersPayants.postInfosComplementairesFacture(data);
                    this.tabErreur = response.Rejets;
                    this.tabRapport = response.Rapports;
                    this.tabRSP = response.NonRapproches;
                    this.tabOperationsPonctuelles = response.Ponctuelles;

                    if (this.tabErreur == undefined) {
                        this.tabErreur = [];
                    }
                    if (this.tabRapport == undefined) {
                        this.tabRapport = [];
                    }
                    if (this.tabRSP == undefined) {
                        this.tabRSP = [];
                    }
                    if (this.tabOperationsPonctuelles == undefined) {
                        this.tabOperationsPonctuelles = [];
                    }


                    if (this.tabErreur.length == 0) {
                        this.tabErreurPlein = false;
                    } else {
                        this.tabErreurPlein = true;
                    }

                    if (this.tabRapport.length == 0) {
                        this.tabRapportPlein = false;
                    } else {
                        this.tabRapportPlein = true;
                    }

                    if (this.tabRSP.length == 0) {
                        this.tabRspPlein = false;
                    } else {
                        this.tabRspPlein = true;
                    }

                    if (this.tabOperationsPonctuelles.length == 0) {
                        this.tabPonctuellePlein = false;
                    } else {
                        this.tabPonctuellePlein = true;
                    }

                    console.log("Résultats du tableau d'erreurs : ", this.tabErreur);
                    console.log("Résultats du tableau des rapports : ", this.tabRapport);
                    console.log("Résultats du tableau des RSP : ", this.tabRSP);
                    console.log("Résultats du tableau des opérations ponctuelles : ", this.tabOperationsPonctuelles);
                } catch (error) {
                    console.error("Erreur lors de l'affichage des informations complémentaires : ", error);
                }
            },
            toggleMenu(facture, estRapproche) {
                if (estRapproche == 'true') {
                    this.rapprocheSelected = true;
                    this.factureActuelle = facture;

                    this.errorMessage = "";
                    this.successMessage = "";
                    this.errorMessageRapport = "";
                    this.successMessageRapport = "";

                    this.modalmenuVisible = true;

                    this.$nextTick(() => {
                        const modalElement = document.getElementById('menuModal');
                        if (modalElement) {
                            modalElement.removeAttribute('aria-hidden');
                            modalElement.removeAttribute('inert');
                        }
                        const modalButton = document.getElementById('openMenuModal');
                        if (modalButton) modalButton.click();
                    });
                } else {
                    this.rapprocheSelected = false;
                    if (facture.no_fact_tla == "0") {
                        this.nofact = facture.code;
                    } else {
                        this.nofact = facture.no_fact_tla;
                    }
                    this.factureActuelle = facture;

                    if (
                        ["lightcoral", "red"].includes(facture.color_champ7)
                    ) {
                        this.rougeAmo = true;
                    } else {
                        this.rougeAmo = false;
                    }

                    if (
                        ["lightcoral", "red"].includes(facture.color_champ8)
                    ) {
                        this.rougeComp = true;
                    } else {
                        this.rougeComp = false;
                    }

                    if (
                        ["lightcoral", "red"].includes(facture.color_champ8) || (["lightgreen"].includes(facture.color_champ8) && this.factureActuelle.attenteReglementComp == "En attente de règlement COMP")
                    ) {
                        this.rougeComp = true;
                    } else {
                        this.rougeComp = false;
                    }

                    if (
                        ["lightcoral", "red"].includes(facture.color_champ7) ||
                        ["lightcoral", "red"].includes(facture.color_champ9)
                    ) {
                        this.rougeAll = true;
                    } else {
                        this.rougeAll = false;
                    }

                    this.errorMessage = "";
                    this.successMessage = "";
                    this.errorMessageRapport = "";
                    this.successMessageRapport = "";

                    this.modalmenuVisible = true;

                    this.$nextTick(() => {
                        const modalElement = document.getElementById('menuModal');
                        if (modalElement) {
                            modalElement.removeAttribute('aria-hidden');
                            modalElement.removeAttribute('inert');
                        }
                        const modalButton = document.getElementById('openMenuModal');
                        if (modalButton) modalButton.click();
                    });
                }
            },
            afficherConfirmationRapprochement(facture) {
                //PROBLEME QUAND JE QUITTE CETTE MODAL SANS CLIQUER SUR UN BOUTON 
                const oldModal = document.getElementById('menuModal');
                if (oldModal) oldModal.style.visibility = 'hidden';
                console.log("Confirmation du rapprochement  :", facture);

                this.$nextTick(() => {
                    const modalElement = document.getElementById('rapprochementModal');
                    if (modalElement) {
                        modalElement.removeAttribute('aria-hidden');
                        modalElement.removeAttribute('inert');
                    }
                    const modalButton = document.getElementById('openRapprochementModal');
                    if (modalButton) modalButton.click();
                });
            },
            async rapprochementManuel() {
                this.rapManuelBool = true;
                this.errorMessageRapport = "";
                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                try {
                    const data = {
                        nofact: this.selectedFacture.code,
                        ID: this.factureActuelle.ID,
                        nofse: this.factureActuelle.Facture
                    };
                    const response = await TiersPayants.postRapprochementManuel(data);
                    console.log("la réponse rapprochement manuel : ", response);
                    if (response != "") {
                        this.errorMessageRapport = response;
                        this.rapManuelBool = false;
                    } else {

                        await delay(2000);

                        this.rapManuelBool = false;

                        this.errorMessageRapport = "";

                        $('#rapprochementModal').modal('hide');
                        this.closeModal('rapprochement');

                        $('#menuModal').modal('hide');
                        this.closeModal('menu');

                        this.errorMessageRapport = "";

                        //this.recherche.recherche = `${this.selectedFacture.nom_patient} ${this.selectedFacture.prenom_patient}`;
                        //this.recherche.nonrapprochees = false;
                        //this.recherche.rapprochees = true;
                        //this.recherche.toutes = false;

                        //await this.rechercherFactures();
                        this.successMessage = "La facture a été rapprochée avec succès !";
                    } 
                } catch (error) {
                    this.rapManuelBool = false;
                    this.errorMessageRapport = "Erreur lors du rapprochement manuel des factures : ", error;
                    console.error("Erreur lors du rapprochement manuel des factures : ", error);
                }
            },
            async visualiserFacture(facture) {
                const oldModal = document.getElementById('menuModal');
                if (oldModal) oldModal.style.visibility = 'hidden';
                console.log("Visualisation de la facture :", facture);
                if (facture.no_fact_tla == "0") {
                    this.nofact = facture.code;
                } else {
                    this.nofact = facture.no_fact_tla;
                }
                try {
                    this.messageFacture = await TiersPayants.getInfosFacture(this.nofact);
                    console.log("Résultat des infos de la facture : ", this.messageFacture);
                    this.modalfactureVisible = true;

                    this.$nextTick(() => {
                        const modalElement = document.getElementById('factureModal');
                        if (modalElement) {
                            modalElement.removeAttribute('aria-hidden');
                            modalElement.removeAttribute('inert');
                        }
                        const modalButton = document.getElementById('openFactureModal');
                        if (modalButton) modalButton.click();
                    });
                } catch (error) {
                    console.error("Erreur lors de l'affichage de la facture : ", error);
                }
            },
            closeModal(facture) {
                document.activeElement?.blur();
                const fallbackFocus = document.getElementById('fallbackFocus');
                if (fallbackFocus) fallbackFocus.focus();

                this[`modal${facture}Visible`] = false;
                const modalElement = document.getElementById(`${facture}Modal`);
                if (modalElement) {
                    modalElement.setAttribute('aria-hidden', 'true');
                    modalElement.setAttribute('inert', 'true');
                }
                const oldModal = document.getElementById('menuModal');
                if (oldModal) oldModal.style.visibility = 'visible';
            },
            ouvrirRenseignementTel() {
                const oldModal = document.getElementById('menuModal');
                if (oldModal) oldModal.style.visibility = 'hidden';
                this.modalRenseignementVisible = true;
                this.errorMessageRapport = "";
                this.successMessageRapport = "";

                this.$nextTick(() => {
                    const modalElement = document.getElementById('renseignementModal');
                    if (modalElement) {
                        modalElement.removeAttribute('aria-hidden');
                        modalElement.removeAttribute('inert');
                    }
                    const modalButton = document.getElementById('openRenseignementModal');
                    if (modalButton) {
                        modalButton.click();
                        //setTimeout(() => {
                        //    this.initQuill();
                        //}, 300);
                    }
                });
            },
            async enregistrerRenseignementTel() {
                if (this.afficherTelephone == true) {
                    if (!this.contrat?.tel || this.contrat.tel.length < 10) {
                        this.errorMessageRapport = "Veuillez saisir un numéro de téléphone valide.";
                        this.successMessageRapport = "";
                        return;
                    }
                    try {
                        let clientActuel = await Client.getClientWithEmail(this.claims.email);
                        //console.log("CLIENT ACTUEL : ", clientActuel);
                        const data = {
                            ...clientActuel,
                            tel: this.contrat.tel
                        };
                        await Client.postUpdateInfosClient(data);
                        this.errorMessage = "";
                        this.successMessage = "";
                        this.errorMessageRapport = "";
                        this.successMessageRapport = "Enregistrement du numéro de téléphone réussi";
                        console.log("Modifications enregistrées du téléphone !");
                        this.afficherTelephone = false;
                    } catch (error) {
                        console.error("Erreur lors des modifications du téléphone : ", error);
                    }
                }
                if (this.afficherRegion == true) {
                    if (this.regionChoisi == "") {
                        this.errorMessageRapport = "Veuillez choisir une région.";
                        this.successMessageRapport = "";
                        return;
                    }
                    try {
                        const maRegion = this.regions.find(region => region.codeRegion === this.regionChoisi)?.nameFile ?? "";

                        await Region.saveRegion(maRegion);
                        this.errorMessage = "";
                        this.successMessage = "";
                        this.errorMessageRapport = "";
                        if (this.successMessageRapport != "") {
                            this.successMessageRapport += " ainsi que de votre région !";
                        } else {
                            this.successMessageRapport = "Enregistrement de votre région réussi !";
                        }
                        console.log("Modifications enregistrées de la région!");
                        this.afficherRegion = false;
                    } catch (error) {
                        console.error("Erreur lors des modifications de la région : ", error);
                    }
                }
                $('#renseignementModal').modal('hide');
                this.closeModal('renseignement');
            },
            async ouvrirReclamationAMO(facture) {
                const oldModal = document.getElementById('menuModal');
                if (oldModal) oldModal.style.visibility = 'hidden';
                await this.codeRecupRegion();
                //console.log("Envoi du rapport pour la facture :", facture);
                if (!this.contrat?.email) {
                    alert("L'email de l'utilisateur est introuvable !");
                    return;
                }

                if ((this.codeRegion == "" || this.codeRegion == "00") && !this.contrat?.tel) {
                    console.log("Il n'y a pas de numéro de téléphone et de région");
                    this.afficherTelephone = true;
                    this.afficherRegion = true;
                    this.ouvrirRenseignementTel();
                    return;
                }
                if (!this.contrat?.tel) {
                    console.log("Il n'y a pas de numéro de téléphone");
                    this.afficherTelephone = true;
                    this.afficherRegion = false;
                    this.ouvrirRenseignementTel();
                    return;
                }
                if (this.codeRegion == "" || this.codeRegion == "00") {
                    console.log("Il n'y a pas de région");
                    this.afficherTelephone = false;
                    this.afficherRegion = true;
                    this.ouvrirRenseignementTel();
                    return;
                }

                this.factureActuelle = facture;
                this.modalRapportAMOVisible = true;
                this.errorMessageRapport = "";
                this.successMessageRapport = "";

                this.$nextTick(() => {
                    const modalElement = document.getElementById('rapportAMOModal');
                    if (modalElement) {
                        modalElement.removeAttribute('aria-hidden');
                        modalElement.removeAttribute('inert');
                    }
                    const modalButton = document.getElementById('openRapportAMOModal');
                    if (modalButton) {
                        this.rapportAMOText = "";
                        modalButton.click();
                        //setTimeout(() => {
                        //    this.initQuill();
                        //}, 300);
                    }
                });
            },
            //initQuill() {
            //    if (!this.quill) {
            //        const container = document.getElementById('editor-container');
            //        if (!container) {
            //            console.error("Container Quill introuvable");
            //            return;
            //        }
            //        const toolbarOptions = [
            //            [{ 'font': [] }],
            //            [{ 'size': ['small', false, 'large', 'huge'] }],
            //            ['bold', 'italic', 'underline'],
            //            [{ 'align': [] }],
            //            [{ list: 'ordered' }, { list: 'bullet' }],
            //            [{ 'color': [] }, { 'background': [] }],
            //            ['clean']
            //        ];
            //        this.quill = new Quill(container, {
            //            theme: 'snow',
            //            placeholder: 'Rédigez votre rapport de réclamation ici...',
            //            modules: { toolbar: toolbarOptions }
            //        });

            // Cette partie du code au niveau du listener ne fonctionne pas, c'était pour garder les styles sélectionnés
            // quand on fait un retour à la ligne ou que ça fonctionne correctement pour les listes de points.
            //        this.quill.root.addEventListener('keydown', (e) => {
            //            if (e.key === 'Enter') {
            //                const range = this.quill.getSelection(true);
            //                if (range && typeof range.index === 'number') {
            //                    console.log("dimensions : ", this.quill.getLine(range.index));
            //                    const [line, offset] = this.quill.getLine(range.index);
            //                    const formats = this.quill.getFormat(range);
            //                    if (formats['list']) {
            //                        setTimeout(() => {
            //                            this.quill.format('list', formats['list']);
            //                        }, 0);
            //                    }
            //                }
            //            }
            //        });

            //        console.log("initQuill lancé");
            //    } else {
            //        this.quill.setContents([]);
            //        console.log("initQuill réinitialisé");
            //    }
                
            //},
            async envoyerRapportAMO() {
                this.rapportLoading = true;
                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                this.errorMessageRapport = "";
                console.log("Contenu du rapport AMO :", this.rapportAMOText);
                console.log("La facture actuelle : ", this.factureActuelle);
                if (this.rapportAMOText == "") {
                    this.errorMessageRapport = "Veuillez rentrer l'objet de votre réclamation.";
                    this.successMessageRapport = "";
                    return;
                }
                let nofacture = "";
                if (this.factureActuelle.no_fact_tla == "0") {
                    nofacture = this.factureActuelle.code;
                } else {
                    nofacture = this.factureActuelle.no_fact_tla;
                }

                try {
                    const data = {
                        mail: this.contrat.email,
                        tel: this.contrat.tel,
                        reclamationText: this.rapportAMOText,
                        nofact: nofacture,
                        partAmo: true,
                        codeRegion: this.codeRegion,
                        idFac: this.contrat.ADELI,
                        rpps: this.contrat.RPPS,
                        double: false
                    };

                    let response = await TiersPayants.postEnvoyerRapportReclamation(data)
                    console.log("La réponse rapport AMO : ", response);
                    if (response == "") {
                        await delay(2000);
                        this.rapportLoading = false;
                        this.errorMessage = "";
                        this.successMessage = "";
                        this.errorMessageRapport = "";
                        this.successMessageRapport = "Votre rapport de réclamation AMO a été envoyé avec succès !";
                        $('#rapportAMOModal').modal('hide');
                        this.closeModal('rapportAMO');
                    } else {
                        await delay(2000);
                        this.rapportLoading = false;
                        this.errorMessage = "";
                        this.successMessage = "";
                        this.errorMessageRapport = `Erreur lors de l'envoie du rapport : ${response}`;
                        this.successMessageRapport = "";
                        return;
                    }  
                } catch (error) {
                    await delay(2000);
                    this.rapportLoading = false;
                    console.error("Erreur lors de l'envoie du rapport de réclamation AMO : ", error);
                    this.errorMessage = "";
                    this.successMessage = "";
                    this.errorMessageRapport = "Une erreur s'est produite lors de l'envoie du rapport de réclamation AMO";
                    this.successMessageRapport = "";
                    return;
                }
            },
            async ouvrirReclamationCOMP(facture) {
                const oldModal = document.getElementById('menuModal');
                if (oldModal) oldModal.style.visibility = 'hidden';
                await this.codeRecupRegion();
                //console.log("Envoi du rapport pour la facture :", facture);
                if (!this.contrat?.email) {
                    alert("L'email de l'utilisateur est introuvable !");
                    return;
                }

                if ((this.codeRegion == "" || this.codeRegion == "00") && !this.contrat?.tel) {
                    console.log("Il n'y a pas de numéro de téléphone et de région");
                    this.afficherTelephone = true;
                    this.afficherRegion = true;
                    this.ouvrirRenseignementTel();
                    return;
                }
                if (!this.contrat?.tel) {
                    console.log("Il n'y a pas de numéro de téléphone");
                    this.afficherTelephone = true;
                    this.afficherRegion = false;
                    this.ouvrirRenseignementTel();
                    return;
                }
                if (this.codeRegion == "" || this.codeRegion == "00") {
                    console.log("Il n'y a pas de région");
                    this.afficherTelephone = false;
                    this.afficherRegion = true;
                    this.ouvrirRenseignementTel();
                    return;
                }

                this.factureActuelle = facture;
                console.log("La facture actuelle : ", this.factureActuelle);
                this.modalRapportCOMPVisible = true;
                this.errorMessageRapport = "";
                this.successMessageRapport = "";

                this.$nextTick(() => {
                    const modalElement = document.getElementById('rapportCOMPModal');
                    if (modalElement) {
                        modalElement.removeAttribute('aria-hidden');
                        modalElement.removeAttribute('inert');
                    }
                    const modalButton = document.getElementById('openRapportCOMPModal');
                    if (modalButton) {
                        this.rapportCOMPText = "";
                        modalButton.click();
                        //setTimeout(() => {
                        //    this.initQuill();
                        //}, 300);
                    }
                });
            },
            async envoyerRapportCOMP() {
                this.rapportLoading = true;
                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                this.errorMessageRapport = "";
                console.log("Contenu du rapport COMP :", this.rapportCOMPText);
                console.log("La facture actuelle : ", this.factureActuelle);
                if (this.rapportCOMPText == "") {
                    this.errorMessageRapport = "Veuillez rentrer l'objet de votre réclamation.";
                    this.successMessageRapport = "";
                    return;
                }
                let nofacture = "";
                if (this.factureActuelle.no_fact_tla == "0") {
                    nofacture = this.factureActuelle.code;
                } else {
                    nofacture = this.factureActuelle.no_fact_tla;
                }

                try {
                    const data = {
                        mail: this.contrat.email,
                        tel: this.contrat.tel,
                        reclamationText: this.rapportCOMPText,
                        nofact: nofacture,
                        partAmo: false,
                        codeRegion: this.codeRegion,
                        idFac: this.contrat.ADELI,
                        rpps: this.contrat.RPPS,
                        double: false
                    };

                    let response = await TiersPayants.postEnvoyerRapportReclamation(data)
                    console.log("La réponse rapport COMP : ", response);
                    if (response == "") {
                        await delay(2000);
                        this.rapportLoading = false;
                        this.errorMessage = "";
                        this.successMessage = "";
                        this.errorMessageRapport = "";
                        this.successMessageRapport = "Votre rapport de réclamation COMP a été envoyé avec succès !";
                        $('#rapportCOMPModal').modal('hide');
                        this.closeModal('rapportCOMP');
                    } else {
                        await delay(2000);
                        this.rapportLoading = false;
                        this.errorMessage = "";
                        this.successMessage = "";
                        this.errorMessageRapport = `Erreur lors de l'envoie du rapport : ${response}`;
                        this.successMessageRapport = "";
                        return;
                    }
                } catch (error) {
                    await delay(2000);
                    this.rapportLoading = false;
                    console.error("Erreur lors de l'envoie du rapport de réclamation COMP : ", error);
                    this.errorMessage = "";
                    this.successMessage = "";
                    this.errorMessageRapport = "Une erreur s'est produite lors de l'envoie du rapport de réclamation COMP";
                    this.successMessageRapport = "";
                    return;
                }
            },
            async ouvrirReclamationAMOCOMP(facture) {
                const oldModal = document.getElementById('menuModal');
                if (oldModal) oldModal.style.visibility = 'hidden';
                await this.codeRecupRegion();
                //console.log("Envoi du rapport pour la facture :", facture);
                if (!this.contrat?.email) {
                    alert("L'email de l'utilisateur est introuvable !");
                    return;
                }

                if ((this.codeRegion == "" || this.codeRegion == "00") && !this.contrat?.tel) {
                    console.log("Il n'y a pas de numéro de téléphone et de région");
                    this.afficherTelephone = true;
                    this.afficherRegion = true;
                    this.ouvrirRenseignementTel();
                    return;
                }
                if (!this.contrat?.tel) {
                    console.log("Il n'y a pas de numéro de téléphone");
                    this.afficherTelephone = true;
                    this.afficherRegion = false;
                    this.ouvrirRenseignementTel();
                    return;
                }
                if (this.codeRegion == "" || this.codeRegion == "00") {
                    console.log("Il n'y a pas de région");
                    this.afficherTelephone = false;
                    this.afficherRegion = true;
                    this.ouvrirRenseignementTel();
                    return;
                }

                this.factureActuelle = facture;
                this.modalRapportAMOCOMPVisible = true;
                this.errorMessageRapport = "";
                this.successMessageRapport = "";

                this.$nextTick(() => {
                    const modalElement = document.getElementById('rapportAMOCOMPModal');
                    if (modalElement) {
                        modalElement.removeAttribute('aria-hidden');
                        modalElement.removeAttribute('inert');
                    }
                    const modalButton = document.getElementById('openRapportAMOCOMPModal');
                    if (modalButton) {
                        this.rapportAMOCOMPText = "";
                        modalButton.click();
                        //setTimeout(() => {
                        //    this.initQuill();
                        //}, 300);
                    }
                });
            },
            async envoyerRapportAMOCOMP() {
                this.rapportLoading = true;
                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
                this.errorMessageRapport = "";
                console.log("Contenu du rapport AMO et COMP :", this.rapportAMOCOMPText);
                console.log("La facture actuelle : ", this.factureActuelle);
                if (this.rapportAMOCOMPText == "") {
                    this.errorMessageRapport = "Veuillez rentrer l'objet de votre réclamation.";
                    this.successMessageRapport = "";
                    return;
                }
                let nofacture = "";
                if (this.factureActuelle.no_fact_tla == "0") {
                    nofacture = this.factureActuelle.code;
                } else {
                    nofacture = this.factureActuelle.no_fact_tla;
                }

                try {
                    const data = {
                        mail: this.contrat.email,
                        tel: this.contrat.tel,
                        reclamationText: this.rapportAMOCOMPText,
                        nofact: nofacture,
                        partAmo: true,
                        codeRegion: this.codeRegion,
                        idFac: this.contrat.ADELI,
                        rpps: this.contrat.RPPS,
                        double: true
                    };

                    let response = await TiersPayants.postEnvoyerRapportReclamation(data);
                    console.log("La réponse rapport AMO et COMP : ", response);
                    if (response == "") {
                        await delay(2000);
                        this.rapportLoading = false;
                        this.errorMessage = "";
                        this.successMessage = "";
                        this.errorMessageRapport = "";
                        this.successMessageRapport = "Votre rapport de réclamation AMO et COMP a été envoyé avec succès !";
                        $('#rapportAMOCOMPModal').modal('hide');
                        this.closeModal('rapportAMOCOMP');
                    } else {
                        await delay(2000);
                        this.rapportLoading = false;
                        this.errorMessage = "";
                        this.successMessage = "";
                        this.errorMessageRapport = `Erreur lors de l'envoie du rapport : ${response}`;
                        this.successMessageRapport = "";
                        return;
                    }
                } catch (error) {
                    await delay(2000);
                    this.rapportLoading = false;
                    console.error("Erreur lors de l'envoie du rapport de réclamation AMO et COMP : ", error);
                    this.errorMessage = "";
                    this.successMessage = "";
                    this.errorMessageRapport = "Une erreur s'est produite lors de l'envoie du rapport de réclamation AMO et COMP";
                    this.successMessageRapport = "";
                    return;
                }
            },
            async forcerPartAMO(facture) {
                this.partLoading = true;
                let nofacture = "";
                if (facture.no_fact_tla == "0") {
                    nofacture = facture.code;
                } else {
                    nofacture = facture.no_fact_tla;
                }
                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

                try {
                    const data = {
                        partAmo: true,
                        nofact: nofacture
                    }
                    let response = await TiersPayants.postForcerPartAMOouAMC(data);

                    await delay(3000);

                    console.log(response);
                    this.partLoading = false;
                    this.recherche.recherche = `${facture.nom_patient} ${facture.prenom_patient}`;
                    this.recherche.nonrapprochees = false;
                    this.recherche.rapprochees = true;
                    this.recherche.toutes = false;

                    this.errorMessage = "";
                    this.successMessage = "";
                    this.errorMessageRapport = "";
                    this.successMessageRapport = "";
                    $('#menuModal').modal('hide');
                    this.closeModal('menu');

                    await this.rechercherFactures();
                    this.secondRequestMessage = "Forcement de la part AMO a été effectué avec succès, mise à jour de la ligne :";
                } catch (error) {
                    console.error("Erreur lors du forcement de la part AMO : ", error);
                    this.partLoading = false;
                    this.errorMessage = "";
                    this.successMessage = "";
                    this.secondRequestMessage = "";
                    this.errorMessageRapport = "Une erreur s'est produite lors du forcement de la part AMO";
                    this.successMessageRapport = "";
                    return;
                }
            },
            async forcerPartCOMP(facture) {
                this.partLoading = true;
                let nofacture = "";
                if (facture.no_fact_tla == "0") {
                    nofacture = facture.code;
                } else {
                    nofacture = facture.no_fact_tla;
                }
                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

                try {
                    const data = {
                        partAmo: true,
                        nofact: nofacture
                    }
                    let response = await TiersPayants.postForcerPartAMOouAMC(data);

                    await delay(3000);

                    console.log(response);
                    this.partLoading = false;
                    this.recherche.recherche = `${facture.nom_patient} ${facture.prenom_patient}`;
                    this.recherche.nonrapprochees = false;
                    this.recherche.rapprochees = true;
                    this.recherche.toutes = false;

                    this.errorMessage = "";
                    this.successMessage = "";
                    this.errorMessageRapport = "";
                    this.successMessageRapport = "";
                    $('#menuModal').modal('hide');
                    this.closeModal('menu');

                    await this.rechercherFactures();
                    this.secondRequestMessage = "Forcement de la part COMP a été effectué avec succès, mise à jour de la ligne :";
                } catch (error) {
                    this.partLoading = false;
                    console.error("Erreur lors du forcement de la part COMP : ", error);
                    this.errorMessage = "";
                    this.successMessage = "";
                    this.secondRequestMessage = "";
                    this.errorMessageRapport = "Une erreur s'est produite lors du forcement de la part COMP";
                    this.successMessageRapport = "";
                    return;
                }
            },
            async solderFacture(facture) {
                this.partLoading = true;
                let nofacture = "";
                if (facture.no_fact_tla == "0") {
                    nofacture = facture.code;
                } else {
                    nofacture = facture.no_fact_tla;
                }
                const delay = ms => new Promise(resolve => setTimeout(resolve, ms));

                try {
                    let response = await TiersPayants.postSolderFacture(nofacture);

                    await delay(3000);

                    console.log(response);
                    this.partLoading = false;
                    this.recherche.recherche = `${facture.nom_patient} ${facture.prenom_patient}`;
                    this.recherche.nonrapprochees = false;
                    this.recherche.rapprochees = true;
                    this.recherche.toutes = false;

                    this.errorMessage = "";
                    this.successMessage = "";
                    this.errorMessageRapport = "";
                    this.successMessageRapport = "";
                    $('#menuModal').modal('hide');
                    this.closeModal('menu');

                    await this.rechercherFactures();
                    this.secondRequestMessage = "La facture a été soldée avec succès, mise à jour de la ligne :";
                } catch (error) {
                    this.partLoading = false;
                    console.error("Erreur pour solder la facture : ", error);
                    this.errorMessage = "";
                    this.successMessage = "";
                    this.secondRequestMessage = "";
                    this.errorMessageRapport = "Une erreur s'est produite pour solder la facture";
                    this.successMessageRapport = "";
                    return;
                }
            },
            // Colonnes du tableau de suivi, partagées par l'impression et l'export
            colonnesGrille() {
                return [
                    { entete: "Date facture", valeur: f => f.date },
                    { entete: "N°fse [lot]", valeur: f => `${f.code}/FSE${f.code} [${f.numero_lot}]` },
                    { entete: "P.s.", valeur: () => `${this.contrat.ADELI}-${this.contrat.nom} ${this.contrat.prenom}` },
                    { entete: "Nom", valeur: f => `${f.nom_patient} ${f.prenom_patient}` },
                    { entete: "Nir", valeur: f => f.nosecu },
                    { entete: "Organisme amo", valeur: f => f.organismeAMO },
                    { entete: "Organisme comp", valeur: f => f.organismeCOMP },
                    { entete: "Mont. amo", valeur: f => f.montantAmo },
                    { entete: "Mont. comp", valeur: f => f.montantComp },
                    { entete: "Mont. total", valeur: f => f.montantTotal },
                    { entete: "Restant dû", valeur: f => f.montantRestant }
                ];
            },
            dateDuJour() {
                let date = new Date();
                let jour = String(date.getDate()).padStart(2, "0");
                let mois = String(date.getMonth() + 1).padStart(2, "0");
                let annee = date.getFullYear();
                return `${jour}/${mois}/${annee}`;
            },
            // Impression de la grille (equivalent Command5/Command6_Click)
            imprimerGrille() {
                if (!this.resultats || this.resultats.length == 0) {
                    return;
                }
                const colonnes = this.colonnesGrille();
                const echapper = v => String(v ?? "")
                    .replace(/&/g, "&amp;")
                    .replace(/</g, "&lt;")
                    .replace(/>/g, "&gt;");

                const entetes = colonnes.map(c => `<th>${echapper(c.entete)}</th>`).join("");
                const lignes = this.resultats.map(f => {
                    const cellules = colonnes.map(c => `<td>${echapper(c.valeur(f))}</td>`).join("");
                    return `<tr>${cellules}</tr>`;
                }).join("");

                const titre = `Suivi des Tiers payants à recevoir au : ${this.dateDuJour()}`;
                const html = `<!DOCTYPE html>
<html lang="fr">
<head>
<meta charset="utf-8" />
<title>${echapper(titre)}</title>
<style>
    body { font-family: Arial, sans-serif; font-size: 11px; margin: 20px; }
    h1 { font-size: 14px; text-align: center; margin-bottom: 16px; }
    table { width: 100%; border-collapse: collapse; }
    th, td { border: 1px solid #888; padding: 4px 6px; text-align: left; }
    thead { background-color: #eee; }
    @media print { @page { size: landscape; } }
</style>
</head>
<body>
    <h1>${echapper(titre)}</h1>
    <table>
        <thead><tr>${entetes}</tr></thead>
        <tbody>${lignes}</tbody>
    </table>
</body>
</html>`;

                const printWindow = window.open("", "_blank");
                if (!printWindow) {
                    this.errorMessage = "Impossible d'ouvrir la fenêtre d'impression (popup bloquée ?).";
                    return;
                }
                printWindow.document.open();
                printWindow.document.write(html);
                printWindow.document.close();
                printWindow.focus();
                printWindow.onload = () => {
                    printWindow.print();
                };
            },
            // Export de la grille en fichier texte tabule (equivalent Command7_Click -> suivitiers.txt)
            exporterGrille() {
                if (!this.resultats || this.resultats.length == 0) {
                    return;
                }
                const colonnes = this.colonnesGrille();
                const nettoyer = v => String(v ?? "").replace(/[\t\r\n]+/g, " ");

                const lignes = [];
                lignes.push(colonnes.map(c => nettoyer(c.entete)).join("\t"));
                for (const f of this.resultats) {
                    lignes.push(colonnes.map(c => nettoyer(c.valeur(f))).join("\t"));
                }
                const contenu = lignes.join("\r\n");

                const encoder = new TextEncoder();
                const utf8Bytes = encoder.encode(contenu);
                const file = new Blob([utf8Bytes], { type: "text/plain;charset=utf-8" });
                const fileURL = URL.createObjectURL(file);
                const lien = document.createElement("a");
                lien.href = fileURL;
                lien.download = "suivitiers.txt";
                document.body.appendChild(lien);
                lien.click();
                document.body.removeChild(lien);
                URL.revokeObjectURL(fileURL);
            }
        },
        mounted() {
            this.fetchClaims();

            this.$nextTick(() => {
                const modals = ['factureModal', 'rapportAMOModal', 'rapportCOMPModal', 'rapportAMOCOMPModal', 'renseignementModal', 'menuModal', 'rapprochementModal'];
                modals.forEach(modalId => {
                    const modalElement = document.getElementById(modalId);
                    if (modalElement && !this[`${modalId}Visible`]) {
                        modalElement.setAttribute('aria-hidden', 'true');
                        modalElement.setAttribute('inert', 'true');
                    }
                });
            });
        }
    });
</script>


